<template>
    <div>
        <portlet
                :icon="'fad fa-file'"
                :title="'Bestanden'"
                v-if="documents.length !== 0"
        >
            <template slot="portletBody">
                <div class="row m-hide-xl">
                    <div class="col">
                        <label>Type</label>
                    </div>
                    <div class="col">
                        <label>Naam</label>
                    </div>
                    <div class="col">
                        <label>Bestand</label>
                    </div>
                    <div class="col last-repeat-col"></div>
                </div>

                <div class="row mb-3 repeater-row documents-table" v-for="(document, index) in documents" :key="document+'-'+index">
                    <div class="col-xl mb-3">
                        <label class="m-show-xl">Type</label>
                        <p>{{document.metaData.type}}</p>
                    </div>
                    <div class="col-xl mb-3">
                        <label class="m-show-xl">Naam</label>
                        <p>{{document.metaData.name}}</p>
                    </div>
                    <div class="col-xl mb-3">
                        <label class="m-show-xl">Bestand</label>
                        <a :href="document.url" class="btn btn-dark btn-block"
                           target="_blank">Download bestand <i class="fal fa-download ml-2"></i>
                        </a>
                    </div>
                    <div class="repeat-row-actions">
                        <i class="far fa-trash-alt" @click="removeDocument(document, index)"></i>
                    </div>
                </div>
            </template>
        </portlet>

        <portlet
                :icon="'fad fa-file-plus'"
                :title="'Bestanden toevoegen'"
                :footer="true"
        >
            <template slot="portletBody">
                <div class="row m-hide-xl">
                    <div class="col">
                        <label>Type</label>
                    </div>
                    <div class="col">
                        <label>Naam</label>
                    </div>
                    <div class="col">
                        <label>Bestand</label>
                    </div>
                    <div class="col last-repeat-col"></div>
                </div>
                <addDocuments
                        v-for="(document,index) in newDocuments"
                        :key="index"
                        :renderedComponent="renderedComponent"
                        :document="document"
                        :documentIndex="index"
                        @documentRemoved="removeDocumentRow($event)"
                ></addDocuments>
            </template>
            <div slot="portletFooter" class="col-12 text-right">
                <button @click="addDocumentRow()" type="submit" class="btn btn-secondary">
                    <i class="fa fa-plus mr-2"></i> Toevoegen
                </button>
                <button @click="saveCustomer" type="submit" class="btn btn-primary ml-3">
                    <i class="fal fa-save mr-2"></i> Opslaan
                </button>
            </div>

        </portlet>
    </div>
</template>

<script>
    import addDocuments from "../../components/addDocuments";
    import {swalModals} from "../../components/mixins/swalModals";

    export default {
        mixins: [swalModals],
        props: ['id'],
        components: {
            addDocuments
        },
        data() {
            return {
                renderedComponent: true,
                documents: [],
                documentsCopy: null,
                newDocuments: [{
                    type: null,
                    name: "",
                    file: null,
                }],
                newDocumentsCopy: null,
                documentTypes: ['ID', 'Certificaat', 'Contract', 'Overig'],
                profilePicture: [],
            }
        },

        methods: {
            saveCustomer() {
                this.$validator.validate().then(result => {
                    if (result) {
                        this.$store.dispatch('customers/set', {id: this.id}).then(docRef => {
                            var documentArray = []
                            _.each(this.newDocuments, (document) => {
                                if (document.file) {
                                    documentArray.push(document)
                                }
                            });

                            _.each(documentArray, (doc) => {
                                doc.path = '/customers/' + docRef + '/';
                            });

                            this.$FB_UPLOADER.upload(documentArray)

                        }).then(() => {
                            this.$toasted.global.successRequest({
                                message: "Bestanden succesvol aangepast"
                            });

                            this.renderComponent();
                            this.$emit('unsavedChanges', false);
                        }).catch(error => {
                            this.$toasted.global.failedRequest();
                        });
                    } else {
                        this.$toasted.global.failedFormRequest();
                    }
                });
            },
            removeDocument(document, index) {
                this.swalDelete(document.metaData.name).then(result => {
                    if (result.value) {
                        this.$FB_STORAGE.ref().child('customers/' + this.id + '/' + this.documents[index].metaData.name).delete().then(function () {
                            console.log('File deleted successfully');
                        }).catch(function (error) {
                            console.log(error);
                        });
                        this.documents.splice(index, 1);
                        this.documentsCopy = this.documents;

                        this.$toasted.global.successRequest({
                            message: 'Bestand verwijderd',
                        });
                    }
                })
            },
            addDocumentRow() {
                this.newDocuments.push({type: null, name: null, file: null});
            },
            removeDocumentRow(index) {
                this.newDocuments.splice(index, 1);
                this.renderComponent();
            },
            renderComponent() {
                this.renderedComponent = false;

                this.$nextTick(() => {
                    this.renderedComponent = true;
                });
            },
        },
        created() {
            var self = this;
            var ref = this.$FB_STORAGE.ref('')
            var documentList = ref.child('customers/' + this.id);
            documentList.listAll().then(function (itemList) {
                itemList.items.forEach(function (itemRef) {
                    itemRef.getDownloadURL().then((documentUrl) => {
                        itemRef.getMetadata().then(meta => {
                            self.documents.push({
                                url: documentUrl,
                                metaData: meta.customMetadata
                            });

                            self.documentsCopy = JSON.parse(JSON.stringify(self.documents));
                            self.newDocumentsCopy = JSON.parse(JSON.stringify(self.newDocuments));
                        })
                    })
                });
            }).catch(function (error) {
                console.log(error)
            });
        },
        watch: {
            documents: {
                handler: function (newV) {
                    this.$emit("unsavedChanges", JSON.stringify(newV) !== JSON.stringify(this.documentsCopy));
                },
                deep: true
            },
            newDocuments: {
                handler: function (newV) {
                    this.$emit("unsavedChanges", JSON.stringify(newV) !== JSON.stringify(this.newDocumentsCopy));
                },
                deep: true
            }
        }
    }
</script>
